<template>
  <div>
    <b-modal
      id="password-modal"
      ref="modal"
      title=""
      hide-footer
      hide-header
      centered
      no-close-on-backdrop
    >
      <div class="header">
        <span class="close-icon" @click="closeModal">
          <img src="@/assets/svg/close.svg" aria-label="close" />
        </span>

        <h3>Изменение пароля</h3>
      </div>

      <div class="w-100 content-modal mt-4">
        <div class="w-100" id="password-change">
          <form ref="form" class="modal-form" @submit.stop.prevent="submit">
            <b-form-group
              label-for="old-password-input"
              invalid-feedback="Некорректный пароль"
            >
              <b-form-input
                type="password"
                id="old-password-input"
                placeholder="Текущий пароль"
                v-model="$v.item.oldPassword.$model"
                :state="validateState($v.item.oldPassword)"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label-for="password-input"
              invalid-feedback="Некорректный пароль"
            >
              <b-form-input
                :type="passwordOpened ? 'text' : 'password'"
                id="password-input"
                placeholder="Новый пароль"
                v-model="$v.item.password.$model"
                :state="validateState($v.item.password)"
                required
              ></b-form-input>

              <span
                class="input-icon"
                v-if="!passwordOpened"
                @click="passwordOpened = !passwordOpened"
              >
                <img src="@/assets/svg/closed-eye.svg" />
              </span>

              <span
                class="input-icon"
                v-if="passwordOpened"
                @click="passwordOpened = !passwordOpened"
              >
                <img src="@/assets/svg/opened-eye.svg" />
              </span>
            </b-form-group>

            <b-form-group
              label-for="new-password-input"
              invalid-feedback="Некорректный пароль"
            >
              <b-form-input
                :type="newPasswordOpened ? 'text' : 'password'"
                id="new-password-input"
                placeholder="Повторите пароль"
                v-model="$v.item.newPassword.$model"
                :state="validateState($v.item.newPassword)"
                required
              ></b-form-input>

              <span
                class="input-icon"
                v-if="newPasswordOpened"
                @click="newPasswordOpened = !newPasswordOpened"
              >
                <img src="@/assets/svg/opened-eye.svg" />
              </span>

              <span
                class="input-icon"
                v-if="!newPasswordOpened"
                @click="newPasswordOpened = !newPasswordOpened"
              >
                <img src="@/assets/svg/closed-eye.svg" />
              </span>
            </b-form-group>
          </form>
        </div>

        <button
          class="button"
          type="submit"
          :class="{ disabled: disabledBtn }"
          @click="submit"
        >
          Сохранить
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import { helpers, required } from "vuelidate/lib/validators";

const email = helpers.regex("email", /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);

export default {
  components: {},

  mixins: [validationMixin],

  validations: {
    item: {
      oldPassword: {
        required,
      },
      password: {
        required,
      },
      newPassword: {
        required,
      },
    },
  },

  data() {
    return {
      item: {
        oldPassword: "",
        password: "",
        newPassword: "",
      },
      passwordOpened: false,
      newPasswordOpened: false,
    };
  },

  computed: {
    ...mapGetters({}),

    disabledBtn() {
      if (
        this.$v.item.$anyError ||
        this.item.newPassword.length < 1 ||
        this.item.password.length < 1 ||
        this.item.oldPassword.length < 1
      )
        return true;
    },
  },

  methods: {
    // ...mapMutations({
    //   getSuccessText: 'getSuccessText',
    //   getErrorText: 'getErrorText'
    // }),

    closeModal() {
      this.$v.$reset();

      ((this.item.oldPassword = ""),
        (this.item.password = ""),
        (this.item.newPassword = ""),
        this.$bvModal.hide("password-modal"));
    },

    validateState(item) {
      const { $dirty, $error } = item;
      return $dirty ? !$error : null;
    },

    submit() {
      this.$v.item.$touch();

      if (this.$v.item.$anyError) return false;

      axios
        .post(
          "user/account/password",
          {
            password: this.item.password,
            old_password: this.item.oldPassword,
            password_confirmation: this.item.newPassword,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "access-control-allow-origin": "*",
              Authorization: "Bearer " + localStorage.getItem("token-bockarev"),
            },
          },
        )
        .then((response) => {
          this.closeModal();

          this.$emit("getThanksTitle", "Изменение пароля");
          this.$emit("getThanksText", "Пароль успешно изменён");
          this.$bvModal.show("thanks-modal");
        })
        .catch((error) => {
          this.closeModal();

          // this.getErrorText(error.response.data.message)
          this.$emit("getErrorText", error.response.data.message);
          this.$bvModal.show("error-modal");
        });
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  flex-direction: column;
  width: 100%;

  .close-icon {
    float: right;
    cursor: pointer;
    transition: 0.4s all;
    margin-right: 5px;

    &:hover {
      opacity: 0.85;
    }
  }
}

.subtext {
  font-family: $regular;
  color: $white;
  font-size: 15px;
  text-align: center;
  margin-top: -5px;
  margin-bottom: 10px;
}

.error {
  font-size: 8px;
  color: red;
  margin-top: -10px;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.button {
  width: 100%;
  max-width: 355px;
  height: 56px;
  font-size: 20px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  background-color: transparent;
  transition: 0.4s all;
  background-image: url("@/assets/button-bg.png");
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% 100%;
  font-weight: 500;
  cursor: pointer;
  color: white;
  margin-top: 40px;

  &:hover {
    background-color: transparent;
    opacity: 0.6;
    transition: 0.4s all;
  }

  &.disabled {
    opacity: 0.6;
  }

  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }
}

.form {
  max-width: 320px;
}

.input-icon {
  right: 15px;
  cursor: pointer;
  margin-top: 2px !important;

  &:hover {
    opacity: 0.8;
  }
}
</style>
